export default class ProjectQuery {

    public static CreateProject = `mutation CreateProjectQuery($input: ProjectInput) {
        createProject(input: $input) {
            id
        }
    }`;

    public static DeleteProject = `mutation DeleteProjectQuery($id: ID!) {
        deleteProject(id: $id) {
            id
        }
    }`;

    public static GetProjectsForAdmin = `query GetProjectsQuery {
        GetProjectsForAdmin {
            id
            identityId
            projectName
            appleBundleId
            appleAppId
            appleId
            applePassword
            appleAccountId
            appleVendorNumber
            appleTeamId
            applePushKeyId
            applePushPrivateKey
            appleFlurryApiKey
            googleAppId
            googleBucketName
            googleClientEmail
            googlePrivateKey
            googleFlurryApiKey
            googleAnalyticsViewId
            pushProjectId
            pushClientEmail
            pushPrivateKey
            pushDatabaseUrl
            pushNotificationTokenUrl
            pushNotificationAppTargetUrl
            reportJson
        }
    }`;

    public static GetProjectsForUser = `query GetProjectsForUserQuery {
        getProjectsForUser {
            id
            identityId
            projectName
            appleBundleId
            appleAppId
            appleId
            applePassword
            appleAccountId
            appleVendorNumber
            appleTeamId
            applePushKeyId
            applePushPrivateKey
            appleFlurryApiKey
            googleAppId
            googleBucketName
            googleClientEmail
            googlePrivateKey
            googleFlurryApiKey
            googleAnalyticsViewId
            pushProjectId
            pushClientEmail
            pushPrivateKey
            pushDatabaseUrl
            pushNotificationTokenUrl
            pushNotificationAppTargetUrl
            reportJson
        }
    }`;

    public static GetProject = `query GetProjectQuery($id: ID) {
        getProject(
            id:$id
        ) {
            id
            identityId
            projectName
            appleBundleId
            appleAppId
            appleId
            applePassword
            appleAccountId
            appleVendorNumber
            appleTeamId
            applePushKeyId
            applePushPrivateKey
            appleFlurryApiKey
            googleAppId
            googleBucketName
            googleClientEmail
            googlePrivateKey
            googleFlurryApiKey
            googleAnalyticsViewId
            pushProjectId
            pushClientEmail
            pushPrivateKey
            pushDatabaseUrl
            pushNotificationTokenUrl
            pushNotificationAppTargetUrl
            reportJson
        }
    }`;
}